// extracted by mini-css-extract-plugin
export default {"item":"rAAPr","itemOrder":"p7TkF","itemText":"gt5aZ"};